import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { ReactSVG } from "react-svg";

import { getSocialLinks } from "../../services/homeRequestServices";
import { mergeArrayByKey } from "../../utilities/merge";

import aparatSvg from "../../assets/media/icons/aparat.svg";
import instagramSvg from "../../assets/media/icons/instagram.svg";
import linkedinSvg from "../../assets/media/icons/linkedin.svg";
import whatsappSvg from "../../assets/media/icons/whatsapp.svg";
import twitterSvg from "../../assets/media/icons/twitter.svg";

const socialNetworkData = [
  {
    title: "instagram",
    icon: instagramSvg,
  },
  {
    title: "linkedin",
    icon: linkedinSvg,
  },
  {
    title: "whatsapp",
    icon: whatsappSvg,
  },
  {
    title: "aparat",
    icon: aparatSvg,
  },
  {
    title: "twitter",
    icon: twitterSvg,
  },
];

const SocialNetworks = () => {
  const [stuckTop, toggleStuckTop] = useState(false);
  const [socialLinksData, changeSocialLinksData] = useState([]);

  const getSocialLinksData = useCallback(() => {
    return getSocialLinks().then((res) =>
      changeSocialLinksData(
        mergeArrayByKey(res.results, socialNetworkData, "title")
      )
    );
  }, []);

  const onScrollChanged = useCallback(() => {
    toggleStuckTop(window.scrollY > 100);
  }, [toggleStuckTop]);

  useEffect(() => {
    getSocialLinksData();
  }, [getSocialLinksData]);

  useLayoutEffect(() => {
    document.addEventListener("scroll", onScrollChanged, { passive: true });
    return () => document.removeEventListener("scroll", onScrollChanged);
  }, [onScrollChanged]);
  console.log(socialLinksData, "socialLinksData");
  return (
    <div
      className={`home_social_networks__container d-flex justify-content-center${
        stuckTop ? " stuck-top" : ""
      }`}
    >
      {socialLinksData?.map((item) => {
        if (item.url) {
        // if (item.icon) {
          return (
            <a
              href={item?.url}
              key={item?.title}
              className="m-2"
              target="_blank"
              rel="noreferrer"
            >
              <ReactSVG src={item?.icon ? item?.icon : "pending"} />
            </a>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default SocialNetworks;
